export const fileFormat = {
  PDF: 'pdf',
  XLS: 'xls',
  CSV: 'csv'
};

export const ORDER_CONFIRMATION = 'OrderDetails';
export const DEALER_CREDIT_ESPOT_NAME = 'DealerCredit_ESPOT';
export const PCC_CREDIT_EXCEEDED_MESSAGE = 'CREDIT_EXCEEDED';
export const CREDIT_EXCEEDED_FLAG = 'PCC_ECTCreditLimitFlag';

export const GUEST_ORDER_STATUS_INQUIRY = 'guestOrderStatusInquiry';
export const DEFAULT_ORDER_FROM_PAGE = 'Order';
